import { LocalizedStringsMethods } from "react-localization";

export const navigation = (strings: LocalizedStringsMethods) => [
  {
    text: "Dashboard",
    path: "/",
    icon: "mediumiconslayout",
  },
  {
    text: "Hesaplar",
    path: "/account",
    icon: "user",
  },
  {
    text: "Ürün Yönetimi",
    icon: "product",
    items: [
      {
        text: "Ürünler",
        path: "/product",
        icon: "product",
      },
      {
        text: "Ürün İstekleri",
        path: "/product-requests",
        icon: "toolbox",
      },
      {
        text: "Ürün Özellikleri",
        path: "/productFeatures",
        icon: "favorites",
      },
    ],
  },

  {
    text: "Kontratlar",
    path: "/contracts",
    icon: "textdocument",
  },
  {
    text: "Bildirimler",
    path: "/notifications",
    icon: "tips",
  },

  {
    text: "Kategoriler",
    path: "/categories",
    icon: "filter",
  },
  {
    text: "Arama Yönetimi",
    icon: "tel",
    items: [
      {
        text: "Arama Durumları",
        path: "/call-status",
        icon: "event",
      },
      {
        text: "Arama Kayıtları",
        path: "/call",
        icon: "tel",
      },
    ],
  },
  {
    text: "Web Yönetim",
    icon: "globe",
    items: [
      {
        text: "Sliders",
        path: "/sliders",
        icon: "image",
      },
      {
        text: "Makaleler",
        path: "/blogs",
        icon: "verticalalignbottom",
      },
      {
        text: "Sıkça Sorulan Sorular",
        path: "/sss",
        icon: "tips",
      },
    ],
  },

  {
    text: "İletişim",
    path: "/contacts",
    icon: "email",
  },
  {
    text: "Destek Yönetimi",
    path: "/tickets",
    icon: "comment",
  },

  {
    text: "Ayarlar",
    icon: "preferences",
    items: [
      {
        text: "Paket Fiyatı",
        path: "/system-price",
        icon: "money",
      },
      {
        text: "Paketler",
        path: "/packages",
        icon: "fields",
      },
      {
        text: "E posta Şablonu",
        path: "/emailTemplate",
        icon: "email",
      },
    ],
  },
];
